import { render, staticRenderFns } from "./MedicalRecordsAdd.vue?vue&type=template&id=44d09d82&scoped=true&"
import script from "./MedicalRecordsAdd.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d09d82",
  null
  
)

export default component.exports